'use client'

import { createContext, type FC, type PropsWithChildren, useMemo } from 'react'

type LoginRegistrationUiContextValue = {
  hideHeading: boolean
}

export const LoginRegistrationUiContext =
  createContext<LoginRegistrationUiContextValue>({
    hideHeading: false,
  })

type LoginRegistrationUiProviderProps = {
  hideHeading?: boolean
}

/**
 * UI-only context to control presentation flags (e.g., hideHeading).
 * Kept separate from the login state context to avoid mixing UI concerns
 * with OTP/login logic and to prevent unintended state resets.
 */
export const LoginRegistrationUiProvider: FC<
  PropsWithChildren<LoginRegistrationUiProviderProps>
> = ({ children, hideHeading = false }) => {
  const value = useMemo(() => ({ hideHeading }), [hideHeading])

  return (
    <LoginRegistrationUiContext.Provider value={value}>
      {children}
    </LoginRegistrationUiContext.Provider>
  )
}
